<!-- Created by henian.xu on 2019/11/24. -->

<template>
    <page>
        <div
            class="body"
            slot="body"
        >
            <el-form
                label-width="10em"
                size="mini"
            >
                <el-form-item label="高拍仪作业:">
                    <HighMeter
                        action="/rs/attachment/uploadCheckinApplyAttachment"
                        :limit="3"
                        v-model="formModel.highMeter"
                    />
                </el-form-item>
                <el-form-item label="与上传组件结合:">
                    <upload
                        action="/rs/attachment/uploadCheckinApplyAttachment"
                        :limit="3"
                        v-model="formModel.highMeter"
                    />
                    <HighMeter
                        action="/rs/attachment/uploadCheckinApplyAttachment"
                        type="button"
                        :limit="3"
                        v-model="formModel.highMeter"
                        button-label="高拍仪选择文件(可以不填此属性)"
                    />
                </el-form-item>
                <el-form-item label="高拍仪识别:">
                    <HighMeterDiscern
                        action="/rs/attachment/uploadFileLibraryWithCheck"
                        check-type="specialOperationOriginal"
                        :limit="3"
                        v-model="formModel.highMeter"
                        @submit='onHDSubmit'
                    />
                </el-form-item>
            </el-form>
            <div>{{ formModel.highMeter }}</div>
        </div>
    </page>
</template>

<script>
export default {
    name: 'HighMeterPage',
    data() {
        return {
            formModel: {
                highMeter: [
                    {
                        address:
                            'http://xcdoa.img-cn-hangzhou.aliyuncs.com/upload/servant/C4CA4238A0B923820DCC509A6F75849B/checkinApply/3b84bc75140d4180b6edfae61d3ad0bc.jpg',
                        name: '3b84bc75140d4180b6edfae61d3ad0bc.jpg',
                    },
                ],
                scanSize: '原始尺寸',
                priModel: 'YUY2',
                priResolution: '2048 * 1536',
                subModel: 'MJPG',
                subResolution: '1920 * 1080',
            },
        };
    },
    methods: {
        async onHDSubmit({ done, data }) {
            done(true, data);
            // done(false);
        },
    },
};
</script>

<style lang="scss">
.device-preview-wrap {
    .item {
        .label {
            font-weight: bold;
        }
        img {
            width: 100%;
            height: auto;
        }
    }
}
.photograph-history {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: stretch;
    flex-wrap: wrap;
    > .item {
        position: relative;
        background-color: $gray2;
        border-radius: $padding-small;
        padding: $padding-small;
        margin: $margin-small;
        > .icon {
            position: absolute;
            top: $padding;
            right: $padding;
            color: $color-success;
            font-size: 120%;
        }
        > .ctrl-wrap {
            /*display: none;*/
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            position: absolute;
            top: $padding-small;
            right: $padding-small;
            bottom: $padding-small;
            left: $padding-small;
            background-color: rgba(0, 0, 0, 0.5);
            padding: $padding;
            > .el-progress {
                > .el-progress__text {
                    color: #fff;
                }
            }
        }
        > .img-obj {
            display: block;
            width: 200px;
            height: 200px * 0.75;
            object-fit: cover;
        }
    }
}
</style>
